import { Fragment } from "react";
import "./CryptoDevelopment.css";
import { cryptocurrencyDevelopment } from "../../staticdata";
import cryptodevbanner from "../../assets/images/services/crypto/cryptodevbanner.jpg";


const CryptoDevelopment = () => {
  return (
    <Fragment>
      <section className="cryptodev-style">
        <div className="cryptodev-banner">
          <div className="row">
            <div className="col-lg-6">
              <div className="cryptodev-desc">
                <h1
                  className="text-start"
                  data-aos="fade-up-right"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  Cryptocurrency Token Development Services
                </h1>
                <p
                  className="text-start"
                  data-aos="fade-up-left"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  Kairaa focuses on providing scalable and secure cryptocurrency
                  development services. Our team of experts is always ready to
                  help you establish a crypto wallet, blockchain ecosystem, or
                  digital currency with perfect execution and top-tier security.
                  We deliver bespoke blockchain and crypto solutions that drive
                  growth and success.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="image-blend-wrapper"
                data-aos="fade-left"
                data-aos-offset="300"
                data-aos-easing="ease-in-sine"
              >
                <img
                  src={cryptodevbanner}
                  alt="image not found"
                  loading="lazy"
                  className=""
                />
              </div>
            </div>
          </div>
        </div>
        <div className="cryptodev-services">
          <div className="container">
            <div
              className="section-title mt-5 mb-5"
              data-aos="fade-down"
              data-aos-duration="800"
            >
              <h2 className="text-center">
                Our{" "}
                <span className="title-gradient">Cryptocurrency Token Development </span>{" "}
                Service
              </h2>
            </div>
            <div className="row gy-4 d-flex justify-content-center">
              {cryptocurrencyDevelopment.map((services, index) => (
                <div
                  className="col-lg-4 col-md-6"
                  key={services.id}
                  data-aos="zoom-in"
                >
                  <div className="crypto-card">
                    <div className="icon-wrap">
                      <img
                        src={services.icon}
                        alt="img not found"
                        style={{ width: "62px", height: "62px" }}
                      />
                    </div>
                    <h5>{services.title}</h5>
                    <p className="text-light mb-0">{services.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default CryptoDevelopment;
